<template>
  <div style="background-color: #f9f9f9;">
    <el-carousel style="width: 100%" height="600px" class="carousel" arrow="never" indicator-position="none">
      <el-carousel-item v-for="item in bannerList" :key="item.id">
        <img :src="item.picUrl" alt="京递快运 - 大货选京递 快速送到家" style="width: 100%; height: 100%" />
      </el-carousel-item>
    </el-carousel>
    <!-- 服务产品 -->
    <div class="service_product">
      <div class="service_content">
        <div class="content_title scrollRevealLeft">
          <span class="content_title_zh" style="color: #333333;">服务产品</span>
          <span class="content_title_en" style="color: rgba(0, 0, 0, .64);">/service products</span>
        </div>
        <div class="service_list">
          <div class="service_item scrollRevealBottom" v-for="(item, index) in serviceList" :key="index">
            <div class="service_item_default" :style="{ background: `url(${item.bg})` }">
              <div class="service_item_content">
                <div class="service_item_title"><span>{{ item.title }}</span></div>
                <div class="service_item_info"><span>{{ item.info }}</span></div>
                <div class="service_item_line"></div>
              </div>
            </div>
            <div class="service_item_checked" :style="{ background: `url(${item.activeBg})` }">
              <div class="service_item_checked_title">{{ item.title }}</div>
              <div class="service_item_content">
                <div class="service_item_info"><span>{{ item.info }}</span></div>
                <div class="service_item_line"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 介绍产品 -->
    <div class="introduce">
      <div class="content_title scrollRevealLeft">
        <span class="content_title_zh" style="color: #333333;">京递快运</span>
        <span class="content_title_en" style="color: rgba(0, 0, 0, .64);">/JD logisticss</span>
      </div>
      <div class="introduce_content">
        <div class="introduce_top">
          <div class="introduce_top_left">
            <div class="introduce_item scrollRevealLeft">
              <img :src="require('@/assets/img/jieshao1.png')" alt="">
              <div class="introduce_item_text">
                <div class="introduce_item_title">京递飞快</div>
                <div class="introduce_item_info">
                  <div></div>
                  <span>发货网点200公里之内预约时间送达，门店</span>
                </div>
              </div>
            </div>
          </div>
          <div class="introduce_top_right">
            <div class="introduce_item scrollRevealRight">
              <img :src="require('@/assets/img/jieshao2.png')" alt="">
              <div class="introduce_item_text">
                <div class="introduce_item_title">京递好快</div>
                <div class="introduce_item_info">
                  <div></div>
                  <span>优先中转 车尾装置 专车派送 专属客服</span>
                </div>
              </div>
            </div>
            <div class="introduce_item scrollRevealBottom">
              <img :src="require('@/assets/img/jieshao3.png')" alt="">
              <div class="introduce_item_text">
                <div class="introduce_item_title">京递标快</div>
                <div class="introduce_item_info">
                  <div></div>
                  <span>大众运价 品质服务</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="introduce_mid">
          <div class="introduce_item scrollRevealBottom">
            <img :src="require('@/assets/img/jieshao4.png')" alt="">
            <div class="introduce_item_text">
              <div class="introduce_item_title">京递跨境</div>
              <div class="introduce_item_info">
                <div></div>
                <span>全国揽收 时效稳定 全程路由 专人服务</span>
              </div>
            </div>
          </div>
        </div>
        <div class="introduce_bottom">
          <div class="introduce_item scrollRevealBottom">
            <img :src="require('@/assets/img/jieshao5.png')" alt="">
            <div class="introduce_item_text">
              <div class="introduce_item_title">冷运快达</div>
              <div class="introduce_item_info">
                <div></div>
                <span>冷链运输 优先派送 专属服务</span>
              </div>
            </div>
          </div>
          <div class="introduce_item scrollRevealBottom">
            <img :src="require('@/assets/img/jieshao6.png')" alt="">
            <div class="introduce_item_text">
              <div class="introduce_item_title">整车直发</div>
              <div class="introduce_item_info">
                <div></div>
                <span>满足客户一辆或多辆用车的整车直达产品</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import scrollReveal from "scrollreveal";
import serviceItemBg1 from '@/assets/img/service_bg1.png'
import serviceItemBg2 from '@/assets/img/service_bg2.png'
import serviceItemBg3 from '@/assets/img/service_bg3.png'
import serviceItemActiveBg1 from '@/assets/img/about_active1.png'
import serviceItemActiveBg2 from '@/assets/img/about_active2.png'
import serviceItemActiveBg3 from '@/assets/img/about_active3.png'
export default {
  metaInfo: {
    title: '京递快运官网 - 服务产品', // set a title
    meta: [{             // set meta
      name: 'keyWords',
      content: '京递快运官网 - 服务产品'
    },
    {
      name: 'description',
      content: '京递 是拥有十五年[互联网十物流]团队创办大货品类快运公司。在扎实的商流驱动物流的远景规划中，以互连互通数智化去拥抱电商市场进军大货快运赛道。以超强的互联网速度和过硬的IT技术，体验中国智造消费流通的便利，高度重视[客户体验]的基础上，顶层追求大货集运。以稳定十时效十温度，通过数字化整合国内网点，完成大货时效保障，踏实极致的塑造伙伴可信赖的供应商。'
    }
    ],
  },
  name: "product",
  data() {
    return {
      bannerList: [
        {
          picUrl: require('@/assets/banner/banner2.png')
        }
      ],
      serviceList: [
        {
          bg: serviceItemBg1,
          activeBg: serviceItemActiveBg1,
          title: '标准达',
          info: '及时配送到客户仓库'
        },
        {
          bg: serviceItemBg2,
          activeBg: serviceItemActiveBg2,
          title: '预约达',
          info: '按照客户需求派送'
        },
        {
          bg: serviceItemBg3,
          activeBg: serviceItemActiveBg3,
          title: '夜班达',
          info: '晚上预约合理派送'
        }
      ],
      scrollReveal: scrollReveal(),
    };
  },
  mounted() {
    this.setScrollReveal();
  },
  methods: {
    setScrollReveal() {
      this.scrollReveal.reveal(".scrollRevealBottom", {
        // 动画的时长
        duration: 800,
        // 延迟时间
        delay: 500,
        // 动画开始的位置，'bottom', 'left', 'top', 'right'
        origin: "bottom",
        // 回滚的时候是否再次触发动画
        reset: false,
        // 在移动端是否使用动画
        mobile: true,
        // 滚动的距离，单位可以用%，rem等
        distance: "300px",
        // 其他可用的动画效果
        opacity: 0,
        easing: "cubic-bezier(0.5, 0, 0, 1)",
        scale: 0.9,
      });
      this.scrollReveal.reveal(".scrollRevealLeft", {
        // 动画的时长
        duration: 800,
        // 延迟时间
        delay: 500,
        // 动画开始的位置，'bottom', 'left', 'top', 'right'
        origin: "left",
        // 回滚的时候是否再次触发动画
        reset: false,
        // 在移动端是否使用动画
        mobile: true,
        // 滚动的距离，单位可以用%，rem等
        distance: "200px",
        // 其他可用的动画效果
        opacity: 0,
        easing: "cubic-bezier(0.5, 0, 0, 1)",
        scale: 0.9,
      });
      this.scrollReveal.reveal(".scrollRevealRight", {
        // 动画的时长
        duration: 800,
        // 延迟时间
        delay: 500,
        // 动画开始的位置，'bottom', 'left', 'top', 'right'
        origin: "right",
        // 回滚的时候是否再次触发动画
        reset: false,
        // 在移动端是否使用动画
        mobile: true,
        // 滚动的距离，单位可以用%，rem等
        distance: "200px",
        // 其他可用的动画效果
        opacity: 0,
        easing: "cubic-bezier(0.5, 0, 0, 1)",
        scale: 0.9,
      });
      this.scrollReveal.reveal(".scrollRevealTop", {
        // 动画的时长
        duration: 800,
        // 延迟时间
        delay: 500,
        // 动画开始的位置，'bottom', 'left', 'top', 'right'
        origin: "top",
        // 回滚的时候是否再次触发动画
        reset: false,
        // 在移动端是否使用动画
        mobile: true,
        // 滚动的距离，单位可以用%，rem等
        distance: "300px",
        // 其他可用的动画效果
        opacity: 0,
        easing: "cubic-bezier(0.5, 0, 0, 1)",
        scale: 0.9,
      });
    },
  }
};
</script>

<style lang="scss" scoped>
.content_title {
  position: relative;
  color: #fff;
  margin: 0 auto;
  margin-bottom: 80px;
  width: 1291px;

  &::before {
    content: '';
    width: 78px;
    height: 13px;
    border-radius: 7px;
    background: #FF8A00;
    position: absolute;
    left: 0;
    bottom: 3px;
    z-index: 1;
  }

  .content_title_zh {
    font-size: 48px;
    font-weight: 500;
    position: relative;
    z-index: 2;
  }

  .content_title_en {
    color: rgba($color: #fff, $alpha: .64);
    font-size: 24px;
    font-weight: 400;
    padding-left: 20px;
  }
}

// 服务产品
.service_product {
  width: 100%;
  // height: 933px;
  // background: url('../../assets/img/product_bg.png') no-repeat;
  // background-size: cover;
  margin-bottom: 90px;

  .service_content {
    width: 1291px;
    margin: 0 auto;
    padding-top: 76px;
  }

  .service_list {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .service_item {
      width: 410px;
      height: 479px;
      position: relative;
      cursor: pointer;

      // overflow: hidden;
      .service_item_default {
        width: 100%;
        height: 100%;
        position: relative;
        background-repeat: no-repeat;
        overflow: hidden;

        .service_item_content {
          padding-top: 280px;
          padding-left: 34px;

          .service_item_title {
            font-size: 26px;
            color: #000;
            font-weight: 600;
            margin-bottom: 11px;
          }

          .service_item_info {
            font-size: 16px;
            font-weight: 400;
            color: #333;
            margin-bottom: 23px;
          }

          .service_item_line {
            width: 36px;
            height: 5px;
            background: #FF8A00;
          }
        }

      }

      .service_item_checked {
        position: absolute;
        left: 0;
        top: 0;
        width: 410px;
        height: 100%;
        // background: rgba($color: #000000, $alpha: .3);
        transform: translate(-410px);
        opacity: 0;
        z-index: 3;
        transition: all .4s;
        pointer-events: none;

        .service_item_checked_title {
          position: absolute;
          left: -18px;
          bottom: 132px;
          width: 171px;
          height: 54px;
          background: linear-gradient(180deg, #FFBE00 0%, #FF8A00 100%);
          border-radius: 0px 100px 100px 0px;
          color: #fff;
          font-size: 26px;
          text-align: center;
          line-height: 54px;
          font-weight: 600;
        }

        .service_item_content {
          padding-top: 358px;
          padding-left: 34px;

          .service_item_info {
            font-size: 16px;
            font-weight: 400;
            color: #fff;
            margin-bottom: 23px;
          }

          .service_item_line {
            width: 36px;
            height: 5px;
            background: #FF8A00;
          }
        }
      }
    }

    .service_item:hover .service_item_checked {
      transform: translate(0px);
      opacity: 1;
    }
  }
}

// 介绍产品
.introduce {
  width: 1291px;
  margin: 0 auto;
  margin-bottom: 97px;

  .introduce_item {
    border-radius: 19px;
    position: relative;
    overflow: hidden;
    cursor: pointer;
    color: #fff;

    img {
      width: 100%;
      height: 100%;
      position: absolute;
      left: 0;
      top: 0;
      z-index: 1;
      transition: all .3s;
    }

    .introduce_item_text {
      position: relative;
      z-index: 2;
      padding-left: 32px;
    }
  }

  .introduce_top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 30px;

    .introduce_top_left {
      width: 630px;
      height: 444px;

      .introduce_item {
        width: 100%;
        height: 100%;

        .introduce_item_text {
          padding-top: 345px;
        }
      }
    }

    .introduce_top_right {
      width: 630px;

      .introduce_item {
        width: 100%;
        height: 207px;
        position: relative;
        margin-bottom: 30px;
        cursor: pointer;

        img {
          width: 100%;
          height: 100%;
          position: absolute;
          left: 0;
          top: 0;
          z-index: 1;
          transition: all .3s;
        }

        .introduce_item_text {
          position: relative;
          z-index: 2;
          padding-left: 32px;
          padding-top: 116px;
        }

        &:last-child {
          margin-bottom: 0;

        }
      }
    }
  }

  .introduce_mid {
    width: 100%;
    height: 232px;
    margin-bottom: 30px;

    .introduce_item {
      width: 100%;
      height: 232px;

      .introduce_item_text {
        padding-top: 140px;
      }
    }
  }

  .introduce_bottom {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .introduce_item {
      width: 630px;
      height: 400px;

      .introduce_item_text {
        padding-top: 301px;
      }
    }
  }

  .introduce_item:hover {
    img {
      transition: all .3s;
      transform: scale(1.1);
    }
  }

  .introduce_item_title {
    font-size: 26px;
    font-weight: 600;
    margin-bottom: 8px;
  }

  .introduce_item_info {
    display: flex;
    font-size: 16px;
    align-items: center;

    div {
      width: 8px;
      height: 8px;
      background: #FF8A00;
      margin-right: 7px;
    }
  }
}
</style>